var _defs, _style, _use, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    width: 600,
    height: 600,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 600,
    height: 600,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAlgAAAJYAQMAAACEqAqfAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAENJREFUeJztwQENAAAAwqD3T20ON6AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAL4NsiAAAfkdBQsAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 0,
    y: 0
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m132.9 257v85h-9.8v-63.6h-18v-6q8.5 0 14-4.2 5.4-4.3 6.3-11.2zm38.7 0v85h-9.8v-63.6h-18v-6q8.5 0 14-4.2 5.4-4.3 6.3-11.2zm19.7 32.9q-2.9 0-5-1.9-2.1-2.1-2.1-4.9 0-3 2.1-4.9 2.1-2 5-2 3 0 4.9 2 2.1 1.9 2.1 4.9 0 2.8-2.1 4.9-2.1 1.9-4.9 1.9zm0 53.1q-2.9 0-5-2-2.1-2.1-2.1-4.9 0-2.9 2.1-4.9 2.1-1.9 5-1.9 3 0 4.9 1.9 2.1 2 2.1 4.9 0 2.8-2.1 4.9-2.1 2-4.9 2zm44.7-86v85h-9.8v-63.6h-18.1v-6q8.6 0 14-4.2 5.5-4.3 6.3-11.2zm38.8 0v85h-9.8v-63.6h-18.1v-6q8.6 0 14-4.2 5.5-4.3 6.3-11.2zm85.6 0l33.9 85h-11.5l-9.1-23.4h-40.1l-9.1 23.4h-11.4l33.8-85zm9.6 52l-16.3-42-16.2 42zm49.5-52l28.7 74.1 28.7-74.1h16.4v85h-10.5v-73.5l-29.2 73.5h-10.7l-29.2-73.5v73.5h-10.5v-85z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.73f6668a3d8420c6a06b68dcfe4dc263.svg";
export { ForwardRef as ReactComponent };